module.exports = __webpack_public_path__ + "static/for-the-love-of-physics-5e235979abc4c4d936e0a6b44651cfce.jpg";